import api from 'Common/Client/Interceptor'

export const learnerActivitiesReportService = {
  getReport: (params) =>
    api.get('/indv/reports/learners/activities', { params }),

  downloadReport: (params) =>
    api.get('/indv/reports/learners/activities/download', {
      params,
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    }),
}
